import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const NOTICES_ROUTES: Routes = [
  {
    path: 'notices/list',
    loadComponent: () => import('../features/notices/list/list.component').then(m => m.NoticesListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'notices/view',
    loadComponent: () => import('../features/notices/view/view.component').then(m => m.NoticesViewComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [
        ROLES.ADMIN,
        ROLES.SUPERADMIN,
        ROLES.EHPAD,
        ROLES.PRATICIEN,
        ROLES.ANIMATEUR,
        ROLES.FAMILLE,
        ROLES.PODOLOGUE,
        ROLES.COIFFEUR,
        ROLES.KINE,
      ],
    },
  },
];
